module.exports = __webpack_public_path__ + "assets/c51840077c684be0e7e13339f85cd4a9.js";